import React from 'react'
import { StyledSelect } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/SelectMode/style'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
const { Option, OptGroup } = StyledSelect

const SelectMode = ({ onChange, isVirtual, interviewType, ...rest }) => {
  return (
    <StyledSelect
      placeholder="Mode"
      suffixIcon={<SelectArrowIcon />}
      onChange={onChange}
      {...rest}
    >
      {<Option value="OFFLINE">Offline</Option>}
      <Option value="EXTERNAL_LINK">External Link</Option>
      {interviewType !== 'ASSESMENT' && (
        <OptGroup label="Online">
          <Option value="EXTERNAL_LINK_1">Google Meet</Option>
        </OptGroup>
      )}
    </StyledSelect>
  )
}

export default SelectMode
